module.exports = {"511181001":"胜利街道","511181002":"峨山街道","511181100":"绥山镇","511181101":"高桥镇","511181102":"罗目镇","511181103":"九里镇","511181104":"龙池镇","511181106":"符溪镇","511181108":"双福镇","511181109":"桂花桥镇","511181110":"大为镇","511181112":"黄湾镇","511181200":"龙门乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511181.json
// module id = 2470
// module chunks = 0